import 'css-chunk:src/components/scrollbar/scrollbar-component.module.scss';export default {
  "scrollbar-container": "scrollbar-component_scrollbar-container__j32KG",
  "content": "scrollbar-component_content__19W8p",
  "y": "scrollbar-component_y__4s-XR",
  "scroll": "scrollbar-component_scroll__PYb0o",
  "x": "scrollbar-component_x__PUKuw",
  "chevron": "scrollbar-component_chevron__YnjDn",
  "scroll-button-disabled": "scrollbar-component_scroll-button-disabled__ZKVyA"
};